module.exports = __webpack_public_path__ + "static/media/logo.3eecde31.svg";